import React from 'react';
import { Box, Button, TextField, InputAdornment, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CustomSelectDropdown from '../../../../../components/CustomSelectDropDown';
import GlobalSearch from '../../../../../components/Search';
import PrimaryButton from '../../../../../components/Button/Button';
import { useCustomParams } from '../../../../../hooks/useCustomParams';

const Filters = ({ statusCounts }) => {
  const isMobile = useMediaQuery("(max-width:690px)");
  const [status, updateStatus] = useCustomParams("status");
  const filterButtons = [
    { label: "Total", value: "all", total: statusCounts?.total || 0 },
    { label: "Pending", value: "pending", total: statusCounts?.pending || 0 },
    {
      label: "Doc's Req'd",
      value: "docs_required",
      total: statusCounts?.docs_required || 0,
    },
    {
      label: "Submitted",
      value: "submitted",
      total: statusCounts?.submitted || 0,
    },

    {
      label: "Removed",
      value: "vio_removed",
      total: statusCounts?.vio_removed || 0,
    },
    {
      label: "Rejected",
      value: "rejected",
      total: statusCounts?.rejected || 0,
    },
    { label: "Overdue", value: "overdue", total: statusCounts?.overdue || 0 },
    {
      label: "Request Dismissal",
      value: "req_dismissal",
      total: statusCounts?.req_dismissal || 0,
    },
    {
      label: "Defect Status",
      value: "defect_status",
      total: statusCounts?.defect_status || 0,
    },
    {
      label: "Abatement Required",
      value: "abate_req",
      total: statusCounts?.abate_req || 0,
    },
    {
      label: "Abatement In Progress",
      value: "abate_prog",
      total: statusCounts?.abate_prog || 0,
    },
    {
      label: "Inspection Requested",
      value: "insp_req",
      total: statusCounts?.insp_req || 0,
    },
    {
      label: "Inspection Scheduled",
      value: "insp_scheduled",
      total: statusCounts?.insp_scheduled || 0,
    },
    {
      label: "Owner Affidavit Required",
      value: "o_affidavit_req",
      total: statusCounts?.o_affidavit_req || 0,
    },
    {
      label: "Vendor Docs",
      value: "vendor_docs",
      total: statusCounts?.vendor_docs || 0,
    },
    {
      label: "Registration Expired",
      value: "reg_expired",
      total: statusCounts?.reg_expired || 0,
    },
    {
      label: "Tenant Denied Access",
      value: "t_denied_access",
      total: statusCounts?.t_denied_access || 0,
    },
  ];

  const dropdownOptions = filterButtons.map((btn) => ({
    label: `${btn.label} ${btn.total}`,
    value: btn.value,
  }));

  return (
    <Box className="hpd-violations-filters bg-white">
      <Box className="filter-buttons">
  
          <CustomSelectDropdown
            options={dropdownOptions}
            label="Filter by Status"
            onSelectChange={(value) => updateStatus("status", value)}
            defaultValue={status}
          />
        
      </Box>
      <GlobalSearch name="search" />
    </Box>
  );
};

export default Filters; 